const TeametAbout = () => {
  const teamMembers = [
    {
      name: "Dr. Inna Tolskaya",
      role: "CEO – Product & Linguistics",
      image: "it.jpg",
      expertise:
        "Linguist, project manager, and software developer with a passion for innovation and e-learning.",
      projects: [
        {
          name: "EasyRights",
          url: "https://www.easyrights.eu/",
          description:
            "Platform helping immigrants understand and use their rights with language and AI support."
        },
        {
          name: "Capeesh",
          url: "https://www.capeesh.com/",
          description:
            "Interactive language-learning app with courses and pronunciation practice."
        }
      ],
      color: "from-blue-50 to-indigo-50",
      borderColor: "border-blue-200",
      roleColor: "text-blue-600"
    },
    {
      name: "Associate professor Olaf Husby",
      role: "CCO – Teaching & Didactics",
      image: "oh.jpg",
      expertise:
        "Pronunciation specialist, second language educator, course developer, and Norwegian dialect expert.",
      projects: [
        {
          name: "NOW: Norwegian on the Web 1",
          url: "https://www.ntnu.edu/now/",
          description:
            "Free beginner Norwegian course with texts, audio, and exercises."
        },
        {
          name: "NOW2: Norwegian on the Web 2",
          url: "https://www.ntnu.edu/now2",
          description:
            "Intermediate Norwegian course for learners with previous knowledge."
        },
        {
          name: "LIM",
          url: "https://www.ntnu.edu/isl/lim",
          description:
            "Language and intercultural learning materials developed at NTNU."
        },
        {
          name: "CALST",
          url: "https://www.ntnu.edu/isl/calst",
          description:
            "Pronunciation training platform with listening and speaking exercises."
        },
        {
          name: "L1-L2 Map",
          url: "https://l1-l2map.it.ntnu.no/",
          description:
            "Tool comparing the sounds of two languages to show what learners should practise."
        },
        {
          name: "Språksnakk, NRK P2",
          url: "https://radio.nrk.no/podkast/spraakteigen",
          description:
            "Norwegian radio podcast answering questions about language and speech."
        }
      ],
      color: "from-purple-50 to-violet-50",
      borderColor: "border-purple-200",
      roleColor: "text-purple-600"
    },
    {
      name: "Dr. Dmitry Shcherbin",
      role: "CTO – Tech & Research",
      image: "ds.jpg",
      expertise:
        "Product leader, software developer, data analyst, and researcher focused on practical applications.",
      projects: [
        {
          name: "CALST",
          url: "https://www.ntnu.edu/isl/calst",
          description:
            "Research-based pronunciation training system for language learners."
        },
        {
          name: "Pygmalion",
          url: "https://pygmalion.hf.ntnu.no/",
          description:
            "Research prototype for multilingual pronunciation training."
        },
        {
          name: "EasyRights",
          url: "https://www.easyrights.eu/",
          description:
            "AI-supported platform helping immigrants understand their rights."
        }
      ],
      color: "from-cyan-50 to-teal-50",
      borderColor: "border-cyan-200",
      roleColor: "text-cyan-600"
    }
  ];

  return (
    <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 lg:p-8 space-y-8">
      {/* Header */}
      <div className="text-center mb-8">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5">
          The Catchphraser Team
        </h1>
        <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full mb-6" />
        <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
          Language learning enthusiasts dedicated to helping you master pronunciation
        </p>
      </div>

      {/* Team Members Grid */}
      <div className="grid lg:grid-cols-3 gap-8">
        {teamMembers.map((member, index) => (
          <div
            key={index}
            className={`bg-gradient-to-br ${member.color} rounded-2xl p-6 border ${member.borderColor} space-y-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1`}
          >
            {/* Profile */}
            <div className="text-center">
              <div className="relative group">
                <div className="w-28 h-28 rounded-full overflow-hidden border-4 border-white shadow-xl mx-auto mb-5">
                  <img
                    src={`${process.env.REACT_APP_USER_API_URL}/uploads/screens/${member.image}`}
                    alt={member.name}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.nextSibling.style.display = "flex";
                    }}
                  />
                  <div className="w-full h-full bg-gradient-to-br from-blue-400 to-purple-500 rounded-full hidden items-center justify-center text-white text-3xl font-bold">
                    {member.name.split(" ").map(n => n[0]).join("")}
                  </div>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {member.name}
              </h3>
              <p className={`text-base ${member.roleColor} font-semibold`}>
                {member.role}
              </p>
            </div>

            {/* Expertise */}
            <section className="space-y-4">
              <div className="flex items-center">
                <div className="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center mr-3">
                  💫
                </div>
                <h3 className="text-lg font-semibold text-gray-800">Expertise</h3>
              </div>
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-5 border border-gray-100 shadow-sm">
                <p className="text-base text-gray-700 leading-relaxed">
                  {member.expertise}
                </p>
              </div>
            </section>

            {/* Projects with hover description */}
            <section className="space-y-4">
              <div className="flex items-center">
                <div className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center mr-3">
                  ✨
                </div>
                <h3 className="text-lg font-semibold text-gray-800">
                  Selected Projects
                </h3>
              </div>

              <div className="space-y-2">
                {member.projects.map((project, projectIndex) => (
                  <div key={projectIndex} className="relative group">
                    <a
                      href={project.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block bg-white rounded-lg p-3 border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all duration-200"
                    >
                      <span className="text-gray-800 font-medium text-md group-hover:text-blue-600">
                        {project.name}
                      </span>
                    </a>

                    {/* Hover tooltip */}
                    <div className="pointer-events-none absolute left-1/2 -translate-x-1/2 top-full mt-2 w-64 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-20">
                      <div className="bg-gray-900 text-white text-md rounded-lg px-3 py-2 shadow-lg">
                        {project.description}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>
        ))}
      </div>

      {/* What We Believe */}
      <section className="space-y-6">
        <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 font-mono text-center mb-8">
          What We Believe
        </h2>

        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-gradient-to-br from-purple-50 to-violet-50 rounded-xl p-6 border border-purple-200 text-center">
            <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center text-white text-2xl mx-auto mb-4">
              🎵
            </div>
            <h4 className="font-semibold text-gray-800 mb-3">
              It's About Rhythm
            </h4>
            <p className="text-sm text-gray-600">
              Good pronunciation isn't just about sounds — it's about the music and flow of speech.
            </p>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 border border-green-200 text-center">
            <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center text-white text-2xl mx-auto mb-4">
              🌱
            </div>
            <h4 className="font-semibold text-gray-800 mb-3">
              Practice Makes Progress
            </h4>
            <p className="text-sm text-gray-600">
              Everyone improves with regular practice and helpful feedback.
            </p>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl p-6 border border-orange-200 text-center">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center text-white text-2xl mx-auto mb-4">
              😊
            </div>
            <h4 className="font-semibold text-gray-800 mb-3">
              Confidence Matters
            </h4>
            <p className="text-sm text-gray-600">
              Feeling good about how you sound helps you communicate more freely.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6 border border-blue-200">
          <p className="text-gray-700">
            <span className="font-semibold">Our approach:</span> We help you sound more like yourself in a new language.
            It’s not about perfection — it’s about clear, confident communication.
          </p>
        </div>
      </section>
    </div>
  );
};

export default TeametAbout;
